const q=(selector,scope=document)=>scope.querySelector(selector);
const qa=(selector,scope=document)=>[...scope.querySelectorAll(selector)];
let activeCartCurrency=q('#CartDrawer')?.dataset.cartCurrency||window.Shopify?.currency?.active||'';

function money(cents,currency=activeCartCurrency){
  const amount=Number(cents||0)/100;
  try{return new Intl.NumberFormat(document.documentElement.lang||undefined,{style:'currency',currency}).format(amount)}
  catch(error){return `${amount.toFixed(2)}${currency?` ${currency}`:''}`}
}

function element(tag,className,text){
  const node=document.createElement(tag);
  if(className)node.className=className;
  if(text!==undefined)node.textContent=text;
  return node;
}

function sellingPlanInterval(plan){
  if(!plan||plan.recurring_deliveries===false)return'';
  const source=[plan.name,plan.description,...(plan.options||[]).map(option=>option?.value||option)].filter(Boolean).join(' ').toLowerCase();
  const cadence=source.match(/every\s+(?:(\d+)\s+)?(day|week|month|year)s?\b/);
  if(cadence){const count=Number(cadence[1]||1);return count===1?cadence[2]:`${count} ${cadence[2]}s`}
  if(/\bdaily\b/.test(source))return'day';
  if(/\bweekly\b/.test(source))return'week';
  if(/\bmonthly\b/.test(source))return'month';
  if(/\b(?:yearly|annual)\b/.test(source))return'year';
  return'delivery';
}

function sellingPlanLabel(plan){
  const interval=sellingPlanInterval(plan);
  if(!interval)return plan?.name||'';
  return interval==='day'?'Daily subscription':interval==='week'?'Weekly subscription':interval==='month'?'Monthly subscription':interval==='year'?'Annual subscription':'Recurring subscription';
}

function openDialog(dialog){
  if(!dialog)return;
  if(dialog.open)return;
  dialog.returnFocus=document.activeElement;
  dialog.showModal();
  qa(`[aria-controls="${dialog.id}"]`).forEach(control=>control.setAttribute('aria-expanded','true'));
  document.body.classList.add('dialog-open');
  requestAnimationFrame(()=>{
    const focusTarget=q('[data-dialog-autofocus]',dialog)||q('[data-dialog-close]',dialog);
    focusTarget?.focus();
  });
}

function closeDialog(dialog){
  if(!dialog?.open)return;
  if(!dialog.classList.contains('cart-drawer')||window.matchMedia('(prefers-reduced-motion: reduce)').matches){dialog.close();return}
  if(dialog.classList.contains('is-closing'))return;
  dialog.classList.add('is-closing');
  dialog.closeTimer=window.setTimeout(()=>dialog.close(),200);
}

qa('[data-dialog-open]').forEach(button=>button.addEventListener('click',()=>openDialog(q(`#${button.dataset.dialogOpen}`))));
qa('[data-dialog-close]').forEach(button=>button.addEventListener('click',()=>closeDialog(button.closest('dialog'))));
qa('dialog').forEach(dialog=>{
  dialog.addEventListener('click',event=>{if(event.target===dialog)closeDialog(dialog)});
  dialog.addEventListener('cancel',event=>{if(dialog.classList.contains('cart-drawer')){event.preventDefault();closeDialog(dialog)}});
  dialog.addEventListener('close',()=>{
    window.clearTimeout(dialog.closeTimer);dialog.classList.remove('is-closing');
    qa(`[aria-controls="${dialog.id}"]`).forEach(control=>control.setAttribute('aria-expanded','false'));
    if(!q('dialog[open]'))document.body.classList.remove('dialog-open');
    if(dialog.returnFocus?.isConnected)dialog.returnFocus.focus();
    dialog.returnFocus=null;
  });
});

qa('[data-localization-form]').forEach(form=>q('select',form)?.addEventListener('change',()=>form.submit()));

async function getCart(){
  const response=await fetch(`${window.PDTheme.routes.cart}.js`,{headers:{Accept:'application/json'},signal:AbortSignal.timeout(15000)});
  if(!response.ok)throw new Error('Cart could not be loaded.');
  return response.json();
}

function cartPhoto(properties={}){
  const legacy=properties['Uploaded Photo URL'],privatePhoto=properties['_Uploaded Photo URL'];
  if(legacy&&privatePhoto&&legacy!==privatePhoto)return '';
  const value=privatePhoto||legacy;
  if(typeof value!=='string'||value.trim()!==value)return '';
  try{const url=new URL(value);return url.origin==='https://diamond-upload.customer-service-3a8.workers.dev'&&!url.username&&!url.password&&url.protocol==='https:'?value:''}catch{return ''}
}
document.addEventListener('error',event=>{
  const img=event.target;if(!(img instanceof HTMLImageElement)||!img.hasAttribute('data-custom-photo'))return;
  img.removeAttribute('data-custom-photo');img.alt='Custom photo preview unavailable; use View image or Edit custom kit.';
  const fallback=img.dataset.photoFallback;if(fallback&&fallback!==img.src)img.src=fallback;else img.removeAttribute('src');
},true);

function cartLine(item,index){
  const title=item.product_title||item.title||'Cart item';
  const properties=Object.entries(item.properties||{}).filter(([key,value])=>value&&key.charAt(0)!=='_'&&key!=='Uploaded Photo URL');
  const photo=cartPhoto(item.properties);
  const image=photo||item.featured_image?.url||item.image;
  const line=element('article','drawer-line');line.dataset.cartLine=String(index+1);line.dataset.cartLineKey=item.key;
  const imageLink=element('a','drawer-line__image');imageLink.href=item.url;
  if(image){const img=element('img');img.src=image;img.alt=photo?`Uploaded photo for ${title}, artwork ${item.properties?._CustomKitInstance||item.properties?.['_Custom Kit Instance']||index+1}`:title;if(photo){img.dataset.customPhoto='';img.dataset.photoFallback=item.featured_image?.url||item.image||'';img.style.objectFit='contain'}img.width=104;img.height=104;img.loading='lazy';imageLink.append(img)}
  line.append(imageLink);

  const content=element('div','drawer-line__content');
  const productLink=element('a','drawer-line__title',title);productLink.href=item.url;content.append(productLink);
  const optionValues=(item.options_with_values||[]).map(option=>option.value).filter(value=>value&&value!=='Default Title');
  const variantText=optionValues.join(' · ')||(item.variant_title&&item.variant_title!=='Default Title'?item.variant_title.replaceAll(' / ',' · '):'');
  if(variantText)content.append(element('p','drawer-line__meta',variantText));
  const sellingPlan=item.selling_plan_allocation?.selling_plan;
  if(sellingPlan){
    content.append(element('p','drawer-line__plan',sellingPlanLabel(sellingPlan)));
  }

  if(properties.length){
    const propertyList=element('div','drawer-line__properties');
    properties.forEach(([key,value])=>{
      const row=element('p');row.append(element('strong','',`${key}: `));
      row.append(document.createTextNode(String(value)));
      propertyList.append(row);
    });
    content.append(propertyList);
  }

  if(photo){
    const utilities=element('div','drawer-line__utilities');
    const edit=element('a','', 'Edit custom kit');
    const editUrl=new URL(item.product_url||item.url,window.location.origin);
    editUrl.searchParams.set('dp_edit','1');editUrl.searchParams.set('dp_photo',String(photo));editUrl.searchParams.set('dp_line',item.key);editUrl.searchParams.set('variant',String(item.variant_id));edit.href=editUrl.href;
    const view=element('a','', 'View image');view.href=String(photo);view.target='_blank';view.rel='noopener';view.setAttribute('aria-label',`View image for ${title}, artwork ${item.properties?.['_Custom Kit Instance']||index+1}`);
    utilities.append(edit,view);content.append(utilities);
  }
  else if(item.properties?.['Uploaded Photo URL']||item.properties?.['_Uploaded Photo URL'])content.append(element('p','drawer-line__meta','Photo reference needs review. Please contact us before checkout.'));

  if(item.line_level_discount_allocations?.length){
    const discounts=element('ul','drawer-line__discounts');discounts.setAttribute('aria-label','Item discounts');
    item.line_level_discount_allocations.filter(allocation=>Number(allocation.amount)>0).forEach(allocation=>{
      const label=allocation.discount_application?.title||'Discount';
      discounts.append(element('li','',`${label} -${money(allocation.amount)}`));
    });
    content.append(discounts);
  }

  const bottom=element('div','drawer-line__bottom');
  const quantity=element('div','quantity drawer-line__quantity');quantity.setAttribute('aria-label',`Quantity for ${title}`);
  const decrease=element('button','', '-');decrease.type='button';decrease.dataset.cartQuantity=String(Math.max(0,item.quantity-1));decrease.setAttribute('aria-label',`Decrease quantity for ${title}`);
  const count=element('span','',String(item.quantity));count.setAttribute('aria-live','polite');
  const increase=element('button','', '+');increase.type='button';increase.dataset.cartQuantity=String(item.quantity+1);increase.setAttribute('aria-label',`Increase quantity for ${title}`);
  quantity.append(decrease,count,increase);bottom.append(quantity);
  const prices=element('div','drawer-line__price');
  if(item.original_line_price>item.final_line_price)prices.append(element('s','',money(item.original_line_price)));
  const finalPrice=element('strong','',money(item.final_line_price));
  const interval=sellingPlanInterval(sellingPlan);if(interval)finalPrice.append(element('small','drawer-line__price-frequency',` / ${interval}`));
  prices.append(finalPrice);bottom.append(prices);content.append(bottom);
  const remove=element('button','text-button drawer-line__remove','Remove');remove.type='button';remove.dataset.cartQuantity='0';remove.setAttribute('aria-label',`Remove ${title} from cart`);content.append(remove);
  line.append(content);return line;
}

function emptyCart(){
  const empty=element('div','cart-drawer__empty');
  empty.append(element('h2','', 'Your cart is empty'));
  const link=element('a','button button--primary-gradient','Shop diamond paintings');link.href=q('#CartDrawer')?.dataset.emptyCartUrl||window.PDTheme.routes.cart;empty.append(link);
  return empty;
}

function showCartError(message='Unable to update your cart. Please try again.'){
  const status=q('[data-cart-drawer-status]');if(status)status.textContent=message;
}

function renderCartDiscounts(cart){
  const container=q('[data-cart-drawer-discounts]');if(!container)return;
  container.replaceChildren(...(cart.cart_level_discount_applications||[]).filter(discount=>Number(discount.total_allocated_amount)>0).map(discount=>{
    const row=element('div');row.append(element('span','',discount.title||'Discount'),element('span','',`-${money(discount.total_allocated_amount)}`));return row;
  }));
}

function renderCart(cart){
  activeCartCurrency=cart.currency||activeCartCurrency;
  const drawer=q('#CartDrawer');if(drawer&&activeCartCurrency)drawer.dataset.cartCurrency=activeCartCurrency;
  qa('[data-cart-count]').forEach(el=>{el.textContent=cart.item_count;el.hidden=cart.item_count===0});
  const contents=q('[data-cart-drawer-contents]');
  if(contents){const extra=contents.querySelector('pd-cart-extra');contents.replaceChildren(...(cart.item_count?cart.items.map(cartLine):[emptyCart()]));if(extra)contents.append(extra);contents.classList.toggle('is-empty',cart.item_count===0);contents.removeAttribute('aria-busy')}
  const footer=q('[data-cart-drawer-footer]');if(footer)footer.hidden=cart.item_count===0;
  const total=q('[data-cart-drawer-total]');if(total)total.textContent=money(cart.total_price);
  renderCartDiscounts(cart);
  const status=q('[data-cart-drawer-status]');if(status)status.textContent='';
  document.dispatchEvent(new CustomEvent('pd:cart:updated',{detail:cart}));
}

async function refreshCart(open=false){
  if(open)openDialog(q('#CartDrawer'));
  try{const cart=await getCart();renderCart(cart);return cart}catch(error){showCartError('Your cart could not be loaded. Please try again.');throw error}
}

document.addEventListener('submit',async event=>{
  const form=event.target.closest('[data-ajax-product-form]');
  if(!form||!window.fetch)return;
  event.preventDefault();
  const button=q('[type="submit"]',form);button?.setAttribute('disabled','');
  try{
    const response=await fetch(window.PDTheme.routes.cartAdd,{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
    const data=await response.json();if(!response.ok)throw new Error(data.description||'Unable to add this item.');
    await refreshCart(true);
    const status=q('[data-product-status]',form);if(status)status.textContent='Added to your cart.';
  }catch(error){const status=q('[data-product-status]',form);if(status)status.textContent=error.message;else alert(error.message)}finally{button?.removeAttribute('disabled')}
});

let drawerUpdating=false;
document.addEventListener('click',async event=>{
  const control=event.target.closest('[data-cart-quantity]');if(!control)return;
  if(drawerUpdating)return;
  const row=control.closest('[data-cart-line]');const key=row?.dataset.cartLineKey;if(!key)return;
  drawerUpdating=true;
  const drawer=q('#CartDrawer');drawer?.setAttribute('aria-busy','true');
  const checkout=q('.cart-drawer__checkout');if(checkout)checkout.disabled=true;
  const controls=qa('[data-cart-quantity]',row);controls.forEach(button=>button.disabled=true);row.setAttribute('aria-busy','true');
  try{
    const current=await getCart();
    if(!current.items.some(item=>item.key===key)){renderCart(current);throw new Error('Your cart changed. Please review the refreshed items and try again.')}
    const response=await fetch(window.PDTheme.routes.cartChange,{method:'POST',signal:AbortSignal.timeout(15000),headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:Number(control.dataset.cartQuantity)})});
    const data=await response.json();if(!response.ok)throw new Error(data.description||'Unable to update your cart.');renderCart(data);
  }catch(error){row.removeAttribute('aria-busy');controls.forEach(button=>button.disabled=false);try{renderCart(await getCart())}catch{}showCartError(`${error.message} Please review your cart before retrying.`);console.error(error)}
  finally{drawerUpdating=false;drawer?.removeAttribute('aria-busy');if(checkout)checkout.disabled=false}
});

const cartTrigger=q('[data-cart-open]');
if(cartTrigger){cartTrigger.setAttribute('aria-controls','CartDrawer');cartTrigger.setAttribute('aria-expanded','false');cartTrigger.addEventListener('click',()=>refreshCart(true).catch(()=>{}))}
window.PDCart={refresh:refreshCart,money,sellingPlanInterval};

const mobileSearch=q('[data-mobile-search]');
if(mobileSearch){
  mobileSearch.addEventListener('click',()=>{
    const menu=mobileSearch.closest('dialog');
    const search=q('#HeaderSearch');
    if(!menu?.open){openDialog(search);return}
    menu.addEventListener('close',()=>openDialog(search),{once:true});
    closeDialog(menu);
  });
}

function initHeaderSearch(dialog){
  if(dialog.dataset.headerSearchReady)return;
  const form=q('[data-header-search-form]',dialog);
  const input=q('[data-header-search-input]',dialog);
  const results=q('[data-header-predictive]',dialog);
  const validation=q('[data-header-search-validation]',dialog);
  if(!form||!input||!results)return;
  dialog.dataset.headerSearchReady='true';
  form.noValidate=true;
  let debounceTimer;
  let requestController;
  let requestNumber=0;

  const hideResults=()=>{
    results.hidden=true;
    results.removeAttribute('aria-busy');
    results.replaceChildren();
    input.setAttribute('aria-expanded','false');
  };
  const showLoading=()=>{
    results.hidden=false;
    results.setAttribute('aria-busy','true');
    results.replaceChildren(element('p','search-predictive__loading','Searching products…'));
    input.setAttribute('aria-expanded','true');
  };
  const loadResults=async(query,number)=>{
    requestController?.abort();
    requestController=new AbortController();
    showLoading();
    try{
      const url=new URL(window.PDTheme.routes.predictiveSearch,window.location.origin);
      url.searchParams.set('q',query);
      url.searchParams.set('resources[type]','product');
      url.searchParams.set('resources[limit]','6');
      url.searchParams.set('resources[options][unavailable_products]','hide');
      url.searchParams.set('section_id','predictive-search');
      const response=await fetch(url,{headers:{Accept:'text/html'},signal:requestController.signal});
      if(!response.ok)throw new Error('Predictive search could not be loaded.');
      const documentFragment=new DOMParser().parseFromString(await response.text(),'text/html');
      const content=q('[data-predictive-content]',documentFragment);
      if(number!==requestNumber||query!==input.value.trim())return;
      if(!content)throw new Error('Predictive search returned no content.');
      results.replaceChildren(...[...content.childNodes].map(node=>node.cloneNode(true)));
      results.removeAttribute('aria-busy');
    }catch(error){
      if(error.name==='AbortError'||number!==requestNumber)return;
      hideResults();
    }
  };

  form.addEventListener('submit',event=>{
    const query=input.value.trim();
    input.value=query;
    if(query)return;
    event.preventDefault();
    validation.textContent='Enter a search term.';
    input.focus();
  });
  input.addEventListener('input',()=>{
    validation.textContent='';
    window.clearTimeout(debounceTimer);
    requestController?.abort();
    const query=input.value.trim();
    requestNumber+=1;
    if(!dialog.open||query.length<2){hideResults();return}
    const number=requestNumber;
    debounceTimer=window.setTimeout(()=>loadResults(query,number),250);
  });
  dialog.addEventListener('close',()=>{
    window.clearTimeout(debounceTimer);
    requestController?.abort();
    requestNumber+=1;
    validation.textContent='';
    hideResults();
  });
}

const carouselObserver='IntersectionObserver'in window?new IntersectionObserver(entries=>{
  entries.forEach(entry=>{
    if(!entry.isIntersecting)return;
    carouselObserver.unobserve(entry.target);
    initCarousel(entry.target);
  });
},{rootMargin:'600px 0px'}):null;
const carouselResizeCallbacks=new WeakMap();
const carouselResizeFallbacks=new Set();
const carouselResizeObserver='ResizeObserver'in window?new ResizeObserver(entries=>entries.forEach(entry=>carouselResizeCallbacks.get(entry.target)?.())):null;
if(!carouselResizeObserver)window.addEventListener('resize',()=>carouselResizeFallbacks.forEach(update=>update()),{passive:true});

function queueCarousel(carousel){
  if(carousel.dataset.pdCarouselReady||carousel.dataset.pdCarouselPending)return;
  if(!carouselObserver){initCarousel(carousel);return}
  carousel.dataset.pdCarouselPending='true';
  carouselObserver.observe(carousel);
}

function initCarousel(carousel){
  if(carousel.dataset.pdCarouselReady)return;
  delete carousel.dataset.pdCarouselPending;
  const track=q('[data-pd-carousel-track]',carousel);
  const items=track?qa('.pd-carousel__item',track):[];
  const previous=q('[data-pd-carousel-prev]',carousel.closest('.pd-home-section')||carousel);
  const next=q('[data-pd-carousel-next]',carousel.closest('.pd-home-section')||carousel);
  const dots=q('[data-pd-carousel-dots]',carousel);
  if(!track||!items.length||!previous||!next)return;
  carousel.dataset.pdCarouselReady='true';
  let frame;
  let dotButtons=[];
  const metrics=()=>{
    const gap=parseFloat(getComputedStyle(track).gap)||0;
    const step=items[0].getBoundingClientRect().width+gap;
    const visible=Math.max(1,Math.round((track.clientWidth+gap)/step));
    return{step,visible,pages:Math.max(1,Math.ceil(items.length/visible))};
  };
  const page=()=>{const {step,visible,pages}=metrics();return Math.min(pages-1,Math.max(0,Math.round(track.scrollLeft/(step*visible))))};
  const go=index=>{const {step,visible,pages}=metrics();track.scrollTo({left:Math.min(pages-1,Math.max(0,index))*step*visible,behavior:'smooth'})};
  const update=()=>{
    const {pages}=metrics();const current=page();
    previous.disabled=current===0;next.disabled=current===pages-1;
    if(dots){
      if(dotButtons.length!==pages){
        dotButtons=Array.from({length:pages},(_,index)=>{
          const dot=document.createElement('button');dot.type='button';dot.className='pd-carousel__dot';dot.setAttribute('aria-label',`Go to carousel page ${index+1}`);dot.addEventListener('click',()=>go(index));return dot;
        });
        dots.replaceChildren(...dotButtons);
      }
      dotButtons.forEach((dot,index)=>{const active=index===current;dot.classList.toggle('is-active',active);if(active)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
    }
  };
  previous.addEventListener('click',()=>go(page()-1));next.addEventListener('click',()=>go(page()+1));
  const scheduleUpdate=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update)};
  track.addEventListener('scroll',scheduleUpdate,{passive:true});
  if(carouselResizeObserver){carouselResizeCallbacks.set(track,scheduleUpdate);carouselResizeObserver.observe(track)}
  else carouselResizeFallbacks.add(scheduleUpdate);
  update();
}

const secondaryImagePointer=window.matchMedia('(hover: hover) and (pointer: fine)');
function hydrateSecondaryProductImages(scope=document){
  if(!secondaryImagePointer.matches)return;
  qa('template[data-product-card-secondary]',scope).forEach(template=>template.replaceWith(template.content.cloneNode(true)));
}
secondaryImagePointer.addEventListener('change',event=>{if(event.matches)hydrateSecondaryProductImages()});

function initVideoFacade(facade){
  facade.addEventListener('click',()=>{
    let source=facade.dataset.pdVideoSrc;if(!source)return;
    source+=source.includes('?')?'&autoplay=1':'?autoplay=1';
    const iframe=document.createElement('iframe');iframe.src=source;iframe.title=facade.dataset.pdVideoTitle||'Painting Diamonds video';iframe.allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';iframe.allowFullscreen=true;
    facade.replaceWith(iframe);
  },{once:true});
}

function initDesktopNavDropdown(details){
  if(details.dataset.desktopNavReady)return;
  details.dataset.desktopNavReady='true';
  const desktopPointer=window.matchMedia('(min-width: 901px) and (hover: hover) and (pointer: fine)');
  const summary=q('summary',details);
  let closeTimer;
  const cancelClose=()=>window.clearTimeout(closeTimer);
  const open=()=>{if(!desktopPointer.matches)return;cancelClose();details.open=true};
  const closeSoon=()=>{if(!desktopPointer.matches)return;cancelClose();closeTimer=window.setTimeout(()=>{if(!details.contains(document.activeElement)&&!details.matches(':hover'))details.open=false},150)};
  details.addEventListener('mouseenter',open);
  details.addEventListener('mouseleave',closeSoon);
  details.addEventListener('focusin',cancelClose);
  details.addEventListener('focusout',closeSoon);
  details.addEventListener('keydown',event=>{
    if(!desktopPointer.matches||event.key!=='Escape'||!details.open)return;
    cancelClose();details.open=false;summary?.focus();event.preventDefault();
  });
  desktopPointer.addEventListener('change',event=>{cancelClose();if(!event.matches)details.open=false});
}

function initThemeComponents(scope=document){qa('.search-popover',scope).forEach(initHeaderSearch);qa('[data-desktop-nav-dropdown]',scope).forEach(initDesktopNavDropdown);hydrateSecondaryProductImages(scope);qa('[data-pd-carousel]',scope).forEach(queueCarousel);qa('[data-pd-video-src]',scope).forEach(initVideoFacade)}
initThemeComponents();
document.addEventListener('shopify:section:load',event=>initThemeComponents(event.target));
document.addEventListener('shopify:section:unload',event=>{
  qa('[data-pd-carousel]',event.target).forEach(carousel=>carouselObserver?.unobserve(carousel));
  qa('[data-pd-carousel-track]',event.target).forEach(track=>{
    const callback=carouselResizeCallbacks.get(track);
    carouselResizeObserver?.unobserve(track);
    if(callback)carouselResizeFallbacks.delete(callback);
    carouselResizeCallbacks.delete(track);
  });
});
